import { z } from 'zod';
import { marketingOptOutSchema } from '../Forms/components/MarketingOptOut/validation';

const FORTY_CHARACTERS = 40;
const EIGHTY_CHARACTERS = 80;

export const campaignFormSchema = z.object({
  first_name: z.string().max(FORTY_CHARACTERS).min(1, 'Required field'),
  last_name: z.string().max(EIGHTY_CHARACTERS).min(1, 'Required field'),
  company: z.string().max(FORTY_CHARACTERS).min(1, 'Required field'),
  email: z.string().min(1, 'Required field').email('Invalid email format').max(EIGHTY_CHARACTERS),
  job_title: z.string().max(EIGHTY_CHARACTERS).optional(),
  country: z
    .object({
      label: z.string(),
      value: z.string(),
    })
    .nullable()
    .transform((data, ctx) => {
      if (data === null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Required field',
        });

        return z.NEVER;
      }

      return data.value;
    }),
  form_type: z.literal('campaign'),
  referral_code: z.string(),
  campaign_id: z.string(),
  campaign_type: z.union([z.literal('gated_asset'), z.literal('event'), z.literal('webinar')]),
  utm_source: z.string().nullable(),
  utm_medium: z.string().nullable(),
  gads_ad_group: z.string().nullable(),
  gads_campaign: z.string().nullable(),
  gads_keyword: z.string().nullable(),
  ...marketingOptOutSchema.shape,
});
